export default "__VITE_ASSET__By06gAYg__"